import "../../_namespaces.js";
window.AssessmentViewer ??= {};
window.AssessmentViewer.Views ??= {};

AssessmentViewer.Views.AssessmentNavigation = class AssessmentNavigation extends Backbone.View {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
  }

  initialize(options = {}) {
    this.options = options;
  }

  render() {
    const controls = [];
    if (this.options.begin) {
      controls.push('<span class="assessment-button begin-assessment-button">Begin</span>');
    }
    if (this.options.previous) {
      controls.push('<span class="assessment-button previous-question-button">Back</span>');
    }
    if (this.options.next) {
      controls.push('<span class="assessment-button next-question-button">Continue</span>');
    }
    if (this.options.startOver) {
      controls.push('<span class="assessment-button start-over-button">Start Over</span>');
    }
    if (this.options.end) {
      controls.push('<span class="assessment-button end-button">End</span>');
    }

    this.$el.html(controls);
    return this;
  }

  // EVENT HANDLERS

  triggerBeginClicked() {
    return this.$el.trigger(AssessmentViewer.Events.AssessmentNavigation.beginClicked);
  }

  triggerPreviousClicked() {
    return this.$el.trigger(AssessmentViewer.Events.AssessmentNavigation.previousClicked);
  }

  triggerNextClicked() {
    return this.$el.trigger(AssessmentViewer.Events.AssessmentNavigation.nextClicked);
  }

  triggerStartOverClicked() {
    return this.$el.trigger(AssessmentViewer.Events.AssessmentNavigation.startOverClicked);
  }

  triggerEndClicked() {
    return this.$el.trigger(AssessmentViewer.Events.AssessmentNavigation.endClicked);
  }
};
AssessmentViewer.Views.AssessmentNavigation.prototype.tagName = "div";
AssessmentViewer.Views.AssessmentNavigation.prototype.className = "assessment-view assessment-view--navigation";

AssessmentViewer.Views.AssessmentNavigation.prototype.events = {
  "click .begin-assessment-button": "triggerBeginClicked",
  "click .next-question-button": "triggerNextClicked",
  "click .previous-question-button": "triggerPreviousClicked",
  "click .start-over-button": "triggerStartOverClicked",
  "click .end-button": "triggerEndClicked",
};
